import {Component, Inject, OnDestroy, ViewEncapsulation} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {ReservationData} from "../../models/reservationData";
import {Observable, of, Subject} from "rxjs";
import {User} from "../../models";
import {TranslateService} from "@ngx-translate/core";
import {Service} from "../../models/service";
import {CardService} from "../../services/card.service";
import {Card} from "../../models/card";


@Component({
    selector: 'confirm-exercise-dialog',
    templateUrl: './confirmExerciseDialog.component.html',
    styleUrls: ['./confirmExerciseDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class ConfirmExerciseDialogComponent implements OnDestroy {
    action: string;
    event: ReservationData;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    eventForm: FormGroup;
    filteredOptions: Observable<User[]>;
    customers: User[];
    form: FormGroup;
    user: User;
    service: Service;
    loadingData: boolean = false;
    card: Card;
    reservationDataId: string;
    error: boolean = false;

    private _unsubscribeAll: Subject<any>;
    
    constructor(
        public matDialogRef: MatDialogRef<ConfirmExerciseDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        private cardService: CardService,
        public _matDialog: MatDialog,
    ) {
        this._unsubscribeAll = new Subject();
        this.translationLoader.loadTranslations(polish);

        this.user = _data.user;
        this.reservationDataId = _data.reservationDataId;

        this.cardService.findCustomerCards(this.user.id).subscribe((cards: Card[]) => {
            this.loadingData = false;
            if (cards.length > 0) {
                this.card = cards[0];
            }
        }, err => {
            this.loadingData = false;
        });
        
        this.service = _data.service;

    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    confirm(): void {
        this.loadingData = true;
        this.cardService.minusItemAndConfirm(this.card.uuid, this.card.cardNumber, this.service.id, this.reservationDataId).subscribe(res => {
            this.loadingData = false;
            this.matDialogRef.close({"refresh": true});
        }, err => {
            this.loadingData = false;
            this.error = true;
        });
    }
}
